import Ease from '../_utils/Ease';
import GetStyleTransformPrefix from '../_utils/GetStyleTransformPrefix';
import SmoothScroll from '../_utils/SmoothScroll';

export default class SingleTeamContent {


	// Constructor
	constructor(element) {

		this.overview = element.querySelector('.single-team-content--overview');
		this.scrollTo = this.scrollTo.bind(this);
		this.scrollToLink = element.querySelector('.single-team-content--title a');
		this.scrollToLink.addEventListener('click', this.scrollTo.bind(this));

		this.posCurrent = 0;
		this.posTarget = 0;
		this.posValue = 0;
		this.scrollTrack = element.querySelector('.single-team-content--scrollbar');
		this.scrollBar = element.querySelector('.single-team-content--scrollbar i');
		this.transform = GetStyleTransformPrefix();

	}


	// Public Methods
	animate() {
		this.posValue = Ease.lerp(this.posValue, this.posTarget, 0.5);
		if (Math.abs(this.posValue - this.posTarget) < Number.EPSILON) {
			this.posValue = this.posTarget;
		}
		if (this.posCurrent !== this.posValue) {
			const y = this.posValue * 100;
			this.scrollBar.style[this.transform] = 'translate3d(0, ' + y + '%, 0)';
		}
		this.posCurrent = this.posValue;
	}
	scroll() {
		const scrollTop = window.scrollY;
		const documentHeight = document.body.offsetHeight;
		const windowHeight = window.innerHeight;
		this.posTarget = scrollTop / (documentHeight - windowHeight);
		if (documentHeight > windowHeight) {
			this.scrollTrack.style.opacity = '1';
		} else {
			this.scrollTrack.style.opacity = '0';
		}
	}



	// Event Handlers
	scrollTo(event) {
		event.preventDefault();
		const y = this.overview.getBoundingClientRect().top + window.pageYOffset - 90;
		SmoothScroll(y, 500, null);
	}


}
